import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { removeUserFromLocalStorage } from '../../../../utils/utils'
import { logoutUser, updatePreferredLanguage } from '../../../../utils/commonSlice'
import { useDispatch, useSelector } from 'react-redux'
import { routePaths } from '../../../../routes/routeConstants'
import ComingSoonDialog from './Dialog'
import LanguageSelector from '../../../../customComponents/LanguageSelector'
import { fetchCartDetails } from '../../../../utils/cartSlice'
import { searchProducts } from '../../Pages/ProductListing/Categories/Apis/productListingSlice'
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'

const Navbar = ({ user }) => {
	const { productQuantity } = useSelector((state) => state.cart)
	const [openDialog, setOpenDialog] = useState(false)
	const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('i18nextLng'))
	const { t } = useTranslation()
	const navigate = useNavigate() // Initialize navigate
	const dispatch = useDispatch()
	const handleSignUserOut = async (e) => {
		e.preventDefault()
		const result = await dispatch(logoutUser())
		if (result?.payload?.data?.status === 1) {
			removeUserFromLocalStorage()
			await dispatch({ type: 'logout' })
			navigate(routePaths.signIn)
		}
	}
	// Function to handle logout

	useEffect(() => {
		if (user) {
			dispatch(fetchCartDetails())
		}
		const body = { search: '' }
		dispatch(searchProducts(body))
	}, [])

	const handleOpenDialog = () => {
		setOpenDialog(true)
	}
	const handleCloseDialog = () => {
		setOpenDialog(false)
	}

	const navigateToSignIn = () => {
		navigate('/UserSignin') // Redirect to the sign-in page
	}
	const navigateToSignUp = () => {
		navigate('/UserSignup') // Redirect to the sign-in page
	}

	const productsSearchChange = (e) => {
		const body = {
			search: e.target.value,
		}
		dispatch(searchProducts(body))
	}

	const handleLanguageChange = (event) => {
		const selectedLanguage = event.target.value
		setSelectedLanguage(event.target.value)
		i18n.changeLanguage(selectedLanguage)
		const body = {
			preferredLanguage: event.target.value,
		}
		dispatch(updatePreferredLanguage(body))
	}

	return (
		<div>
			<nav class='navbar navbar-expand-lg position-fixed top-0 bg-white z-index-3 background-image-yellow mx-auto w-100 text-nowrap nav-height'>
				<div class='container w-100 p-1 '>
					<Link class='navbar-brand ' to='/'>
						<img src='../../assets/img/salarnew.png' alt='' width='100' height='100' />
					</Link>
					<a href='.' className='me-1'>
						<div className='reg-id-box'>
							<div className='reg-id-letter'>
								<img src='../../assets/img/india.png' height='24' width='24' alt='' />
							</div>
							<div className='ms-1 flex-column d-flex'>
								<div className='reg-id-name'>{user?.data?.fullName}</div>
								<div className='reg-id'>
									<span className='dropdown-toggle'>{user?.data?.city}, India</span>
								</div>
							</div>
						</div>
					</a>
					<div
						style={{
							height: '65px',
						}}
						class='navbar-collapse align-items-center'
						id='navbarSupportedContent'
					>
						<ul class='navbar-nav me-auto gap-1 text-nowrap text-capitalize mt-5 '>
							<ComingSoonDialog open={openDialog} handleClose={handleCloseDialog} />
						</ul>
						<div className='input-group input-group-outline-two input-group-md me-2 ms-2 align-items-center has-search'>
							<div className=' form-control-feedback'>
								<img src='../../assets/img/svg/search.svg' height='19' width='19' alt='' />
							</div>
							<input
								type='text'
								className='form-control bg-none'
								placeholder='Search everything at Salar online and in store...'
								name=''
								id=''
								onChange={productsSearchChange}
							/>
						</div>
						<form className='row ms-2'>
							<ul class='navbar-nav me-auto justify-content-end align-items-center mt-1 mb-lg-0'>
								{user && (
									<>
										<li className='nav-item dropdown dropdown-hover cursor-pointer'>
											<b
												className='nav-link text-xs text-black fw-bold'
												id='dropdownMenuButton'
												data-bs-toggle='dropdown'
												aria-expanded='false'
											>
												<b className='fs-6 text-normal dropdown-toggle'>
													{selectedLanguage === 'en'
														? 'English - Ind'
														: selectedLanguage === 'bn'
														? 'Bengali - Ind'
														: selectedLanguage === 'gu'
														? 'Gujarati - Ind'
														: selectedLanguage === 'hi'
														? 'Hindi - Ind'
														: selectedLanguage === 'kn'
														? 'Kannada - Ind'
														: selectedLanguage === 'ml'
														? 'Malayalam - Ind'
														: selectedLanguage === 'mr'
														? 'Marathi - Ind'
														: selectedLanguage === 'or'
														? 'Odia - Ind'
														: selectedLanguage === 'pa'
														? 'Panjabi - Ind'
														: selectedLanguage === 'ta'
														? 'Tamil - Ind'
														: selectedLanguage === 'te'
														? 'Telugu - Ind'
														: selectedLanguage}
												</b>
											</b>
											{/* <ul className='dropdown-menu px-2 py-0' aria-labelledby='dropdownMenuButton' style={{ width: '20em' }}>
												<div className='p-2'>
													<div className='lh-1 text-wrap'>
														<b className='fs-0 text-black fw-bold'>Set your Language</b>
														<div className='mt-2'>
															<small>Select your preferred language. You can update the settings at any time.</small>
														</div>
													</div>
													<div className='mt-3 justify-content-center'>
														<li>
															<div className=' input-group input-group-outline input-group-sm'>
																<select
																	name='choice-button'
																	className='form-control fs-6'
																	id='choice-button'
																	placeholder='Language'
																	value={selectedLanguage}
																	onChange={handleLanguageChange}
																>
																	<option value='en'>English</option>
																	<option value='hi'>Hindi</option>
																	<option value='te'>Telugu</option>
																	<option value='ta'>Tamil</option>
																	<option value='kn'>Kannada</option>
																	<option value='ml'>Malayalam</option>
																	<option value='bn'>Bengali</option>
																	<option value='gu'>Gujarati</option>
																	<option value='mr'>Marathi</option>
																	<option value='or'>Odia</option>
																	<option value='pa'>Panjabi</option>
																</select>
															</div>
														</li>
													</div>
												</div>
											</ul> */}
										</li>
										<li class='nav-item cursor-pointer'>
											<Link
												to='/user/dashboard'
												class='nav-link text-xs ms-2 fw-bolder text-black'
												// data-bs-toggle='dropdown'
												// id='navbarDropdownMenuLink2'
											>
												<b className='fs-7 btn btn-white btn-md text-bold'>{t('myProfile')}</b>
												{/* <ul class='dropdown-menu profile-dropdown p-3' aria-labelledby='navbarDropdownMenuLink2'>
												<div className='row d-flex justify-content-between align-items-start'>
													<div className='col pro-dropdown-list'>
														<li>
															<a class='dropdown-item mb-2 ' href='#'>
																<b className='text-black fw-normal text-sm'>
																	<span className='me-2 opacity-4'>
																		<img src='../../assets/img/svg/withdrawl.svg' height='15' alt='' />
																	</span>{' '}
																	Withdrawl
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-3 opacity-10'>
																		<img src='../../assets/img/svg/earnings.svg' height='15' alt='' />
																	</span>
																	Earnings
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-3 opacity-10'>
																		<img
																			src='../../assets/img/svg/tickets.svg'
																			className='ms-1'
																			height='15'
																			alt=''
																		/>
																	</span>
																	Tickets
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-3 opacity-10'>
																		<img src='../../assets/img/svg/wallet.svg' height='18' alt='' />
																	</span>
																	Wallet
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-3'>
																		<img src='../../assets/img/svg/star.svg' height='15' alt='' />
																	</span>
																	Testimonials
																</b>
															</a>
														</li>
													</div>
													<div className='col border-start'>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-2 opacity-10'>
																		<img src='../../assets/img/svg/homedashboard.svg' height='15' alt='' />
																	</span>
																	Your Dashboard
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-2 opacity-10'>
																		<img src='../../assets/img/svg/person.svg' height='15' alt='' />
																	</span>
																	Your Account
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-2 opacity-10'>
																		<img src='../../assets/img/svg/team.svg' height='10' alt='' />
																	</span>
																	Your Team
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-2 opacity-10'>
																		<img src='../../assets/img/svg/orders.svg' height='15' alt='' />
																	</span>
																	Your Orders
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-2 opacity-10'>
																		<img src='../../assets/img/svg/redheart.svg' height='15' alt='' />
																	</span>
																	Your wishlist
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-2 opacity-10'>
																		<img src='../../assets/img/svg/recommend.svg' height='10' alt='' />
																	</span>
																	Your Recommendations
																</b>
															</a>
														</li>
														<li>
															<a class='dropdown-item mb-2 opacity-7' href='#'>
																<b className='text-black fw-normal'>
																	<span className='me-2 opacity-10'>
																		<img src='../../assets/img/svg/portfolio.svg' height='15' alt='' />
																	</span>
																	My Portfolio
																</b>
															</a>
														</li>
													</div>
												</div>
											</ul> */}
											</Link>
										</li>

										<li class='nav-item'>
											<Link class='nav-link text-xs text-black fw-bolder' to='/user/ReferralComm'>
												<b className='fs-7 text-normal'>{t('myEarnings')}</b>
											</Link>
										</li>
										<li class='nav-item'>
											<Link class='nav-link' to='/user/WithdrawlRequest'>
												<div className='icon icon-md-2 bg-white border shadow text-center rounded-circle p-1 pt-1'>
													<img
														className=' mt-1'
														src='../../assets/img/svg/withdrawlicon.svg'
														height='18'
														width='18'
														alt=''
													/>
												</div>
												{/* <b className='fs-7 text-normal'>Withdrawal</b> */}
											</Link>
										</li>
										<li class='nav-item'>
											<Link class='nav-link mt-3' aria-current='page' to='/Cart'>
												<sup>
													{' '}
													<sup>
														{' '}
														<Link to='/FooterTestimonials'>
															<div className='icon icon-md-2 bg-white border shadow text-center rounded-circle p-1 pt-2'>
																<i className='bi bi-star-fill fs-5 text-danger opacity-9'></i>
															</div>
														</Link>
													</sup>
												</sup>
											</Link>
										</li>
										<li class='nav-item'>
											<Link class='nav-link mt-3' aria-current='page' to='/Cart'>
												<sup>
													{' '}
													<sup>
														{' '}
														<a href=''>
															<div className='icon icon-md-2 bg-white border shadow text-center rounded-circle p-1 pt-2'>
																<i className='bi bi-bell-fill fs-5 text-danger opacity-9'></i>
															</div>
															{/* <span class='position-absolute translate-middle text-dark border-white  py-1 px-1'>
														<span class='text-md'>{`${0}`}</span>
													</span> */}
														</a>
													</sup>
												</sup>
											</Link>
										</li>
										<li class='nav-item'>
											<Link className='nav-link mt-3' aria-current='page' to={user ? '/Cart' : '/UserSignin'}>
												<sup>
													{' '}
													<sup>
														{' '}
														<a href='#'>
															<div className='icon icon-md-2 bg-white border shadow text-center rounded-circle p-1 pt-2'>
																<i className='bi bi-handbag-fill fs-5 text-primary opacity-9'></i>
															</div>
															<span
																class='position-absolute translate-middle text-dark  border-white '
																style={{ top: '-8px', left: '30px' }}
															>
																<span class='text-md'>{`${productQuantity ?? 0}`}</span>
															</span>
														</a>
													</sup>
												</sup>
											</Link>
										</li>
									</>
								)}

								{user ? (
									<li class='nav-item'>
										<button
											class='nav-link text-xs text-black fw-bolder'
											onClick={(e) => handleSignUserOut(e)} // Attach the logout handler
										>
											{/* <img src='../../assets/img/svg/exit.svg' className='me-0' width='20' height='20' alt='' />{' '} */}
											<b className='fs-7 btn btn-white btn-md text-bold'>{t('logout')}</b>
										</button>
									</li>
								) : (
									<>
										<li
											class='nav-item '
											style={{
												border: 'none',
											}}
										>
											<button
												class='btn btn-white btn-md fw-bolder me-2 w-100'
												onClick={navigateToSignIn} // Attach the logout handler
											>
												<img src='../../assets/img/svg/exit.svg' className='me-1' width='20' height='20' alt='' /> SignIn
											</button>
										</li>
										<li
											class='nav-item '
											style={{
												border: 'none',
											}}
										>
											<button
												class='btn btn-white btn-md fw-bolder ms-2 w-100'
												onClick={navigateToSignUp} // Attach the logout handler
											>
												<img src='../../assets/img/svg/Signup.svg' className='me-1' width='20' height='20' alt='' /> SignUp
											</button>
										</li>
									</>
								)}
							</ul>
						</form>
					</div>
				</div>
			</nav>
		</div>
	)
}

export default Navbar
